import * as React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { GoogleMapWrapper } from './GoogleMapWrapper.tsx'
import { useSnapshot } from 'valtio'
import { controlState } from '../../../../store/controlState.ts'
import { HAWAII, INITIAL_ZOOM } from '../../types.ts'

export const MapLayout: React.FC = () => {
    const isMobile = useSnapshot(controlState).isOnMobileDevice
    const location = useLocation()
    const isHistory = location.pathname.includes('history')
    
    // Use the full 100vh on mobile to prevent an empty gap at the bottom that looks like a footer
    // On desktop, the map shouldn't position absolutely over the NavBar, it should just fill its relative container
    const isDesktopHistory = !isMobile && isHistory;
    
    const height = isMobile ? '100vh' : '100%';
    
    const containerStyle: React.CSSProperties = isMobile 
        ? { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }
        : { position: 'relative', width: '100%', height: '100%', zIndex: 0 }

    return (
        <React.Fragment>
            <div style={containerStyle} className={isDesktopHistory ? 'bg-base-200' : ''}>
                <GoogleMapWrapper 
                    height={height} 
                    center={HAWAII} 
                    zoom={INITIAL_ZOOM} 
                    isHistory={isHistory}
                >
                    <Outlet />
                </GoogleMapWrapper>
            </div>
        </React.Fragment>
    )
}
